/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNumber14Small = createReactComponent("number-14-small", "IconNumber14Small", [
  ["path", { d: "M7 10l2 -2v8", key: "svg-0" }],
  ["path", { d: "M13 8v3a1 1 0 0 0 1 1h3", key: "svg-1" }],
  ["path", { d: "M17 8v8", key: "svg-2" }]
]);

export { IconNumber14Small as default };
//# sourceMappingURL=IconNumber14Small.js.map
